import { Outlet } from "react-router-dom";
import { DesignerModeProvider } from "../Contexts/DesignerModeContext";

/**
 * Layout component that provides DesignerModeProvider inside the router context.
 * This allows DesignerModeProvider to use useNavigate() and useLocation().
 * DesignerModeProvider uses the global IsDesignMode constant to detect iframe mode.
 */
export function DesignerModeLayout() {
  return (
    <DesignerModeProvider>
      <Outlet />
    </DesignerModeProvider>
  );
}
